import Skeleton from "react-loading-skeleton";
import { ErrorMessage, ErrorMessageWrapper } from "../../../components/messages";
import { InfoBubbleNotesWrapper } from "../components";
import useBackgroundSection from "../hooks/useBackgroundSection";

const BackgroundSection = () => {
    const [{
        patchNotes,
        refetch
    }, {
        section,
        isLoading,
        isError,
        error
    }] = useBackgroundSection();

    return <div className="container-fluid">
        {isLoading
            ? <Skeleton height={16} count={4} />
            : isError || error
                ? <ErrorMessageWrapper>
                    <ErrorMessage error={error} retryCallback={refetch} />
                </ErrorMessageWrapper>
                : <InfoBubbleNotesWrapper
                    fieldKey={"background"}
                    defaultValue={section?.notes?.notes}
                    onBlur={patchNotes}
                />}
    </div>
}

export default BackgroundSection;